import {Component} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {InputBaseComponent} from '../0-base/input-base.component'

@Component({
  selector: 'spb-private-email',
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    MatError,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './private-email.component.html',
  providers: [{provide: InputBaseComponent, useExisting: PrivateEmailComponent}]
})
export class PrivateEmailComponent extends InputBaseComponent<string> {
  protected override prop = 'privateEmail'
}
